/**
 * Which headcount design is showing: preset tiles, or a counter.
 *
 * Tiles are the default every time, for the same reason the meal layout is:
 * a remembered choice that nothing on screen explains is a piece of invisible
 * state. The toggle is in the header; it costs one tap per visit.
 */

import { useCallback, useState } from 'react';

export type QuantityLayout = 'tiles' | 'stepper';

export const DEFAULT_QUANTITY_LAYOUT: QuantityLayout = 'tiles';

export function useQuantityLayout(): [QuantityLayout, () => void] {
  const [layout, setLayout] = useState<QuantityLayout>(DEFAULT_QUANTITY_LAYOUT);
  const toggle = useCallback(
    () => setLayout((current) => (current === 'tiles' ? 'stepper' : 'tiles')),
    [],
  );
  return [layout, toggle];
}
